<template>

	<div class="container">
		<auth-component v-if="!userLogedIn"></auth-component>
	</div>
</template>
<script>
	import Vue from 'vue';
	import Vuex from 'vuex';
	import Auth from './Auth';

	export default {
		name: 'AuthPage',
		components: {
			'auth-component': Auth
		},
		data() {
			return {}
		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				user: 'getUser',
				userLogedIn: 'getUserStatus'
			}),
			redirect(){
				return this.$route.query.redirect ? this.$route.query.redirect: null;
			}
		},
		watch: {
			userLogedIn(value) {
				if (value) {

					if(this.redirect){
						this.$router.push({path: this.redirect});
					}else{
						this.$router.push({name: 'Home'});
					}

				}
			}
		},
		mounted() {

		}
	}
</script>
<style lang="scss">
	@import "../../scss/components/auth";
</style>